export default __webpack_public_path__ + "static/media/ranked-match.b786200b.svg";